var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('el-button',{attrs:{"disabled":_vm.disabled,"type":"info","loading":_vm.loading,"plain":"","size":"small"},on:{"click":_vm.requestWorkflowInfo}},[_c('i',{staticClass:"fa fa-retweet"}),_vm._v(" 发送工作流\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }